import { USERS_CLIENT as userClient } from "../common";

export default {
  namespaced: true,
  actions: {
    async listUsers({ dispatch, rootGetters }) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];
      const users = await userClient.get("/", {
        headers: { Authorization: `Bearer ${jwtToken}` },
      });

      return users.data;
    },
    async promoteUser({ dispatch, rootGetters }, { email, phoneNumber }) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];

      await userClient.put(
        `/${email}`,
        {
          email,
          name: email,
          phoneNumber,
          isAdmin: true,
        },
        {
          headers: { Authorization: `Bearer ${jwtToken}` },
        }
      );
    },
    async demoteUser({ dispatch, rootGetters }, { email, phoneNumber }) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];

      await userClient.put(
        `/${email}`,
        {
          email,
          name: email,
          phoneNumber,
          isAdmin: false,
        },
        {
          headers: { Authorization: `Bearer ${jwtToken}` },
        }
      );
    },
    async deleteUser({ dispatch, rootGetters }, { email }) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];

      await userClient.delete(`/${email}`, {
        headers: { Authorization: `Bearer ${jwtToken}` },
      });
    },
    async createUser(
      { dispatch, rootGetters },
      { email, phoneNumber, isAdmin }
    ) {
      await dispatch("auth/checkUserSession", {}, { root: true });
      const jwtToken = rootGetters["auth/getIdentityToken"];

      await userClient.post(
        "/",
        {
          email,
          isAdmin,
          phoneNumber,
          name: email,
        },
        { headers: { Authorization: `Bearer ${jwtToken}` } }
      );
    },
  },
};
